import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SectionHeader, Pill } from "@/components/Brand";

const ACTION_TONES = {
  create_surveyor: "green",
  approve_candidate: "green",
  delete_user: "red",
  delete_ward: "red",
  delete_booth: "red",
  create_ward: "blue",
  create_booth: "blue",
  update_ward: "yellow",
  update_booth: "yellow",
  submit_survey: "blue",
  purchase_ward: "green",
  grant_access: "green",
  revoke_access: "red",
  clear_temp_data: "red",
  update_form_template: "yellow",
  update_settings: "yellow",
};

export default function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [filter, setFilter] = useState("");

  useEffect(() => {
    api.get("/admin/audit-log").then((r) => setLogs(r.data));
  }, []);

  const filtered = logs.filter(
    (l) =>
      !filter ||
      l.action.includes(filter.toLowerCase()) ||
      (l.actor_email || "").includes(filter.toLowerCase()),
  );

  return (
    <div>
      <SectionHeader eyebrow="Compliance" title="Audit Log" />
      <div className="wi-card p-4 mb-4">
        <input
          placeholder="Filter by action or user email…"
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          data-testid="audit-filter-input"
          className="w-full text-sm border border-slate-300 rounded-md px-3 py-2"
        />
      </div>
      <div className="wi-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>
              {["Timestamp", "Actor", "Role", "Action", "Target", "Meta"].map((h) => (
                <th key={h} className="text-left px-4 py-3 data-label">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && <tr><td colSpan={6} className="px-4 py-6 text-center text-slate-500">No audit entries yet.</td></tr>}
            {filtered.map((l) => (
              <tr key={l.id} className="border-b border-slate-100" data-testid={`audit-row-${l.id}`}>
                <td className="px-4 py-3 font-mono text-[11px] text-slate-500">{(l.timestamp || "").replace("T", " ").slice(0, 19)}</td>
                <td className="px-4 py-3 font-mono text-xs">{l.actor_email}</td>
                <td className="px-4 py-3"><Pill tone={l.actor_role === "admin" ? "blue" : l.actor_role === "surveyor" ? "green" : "yellow"}>{l.actor_role}</Pill></td>
                <td className="px-4 py-3"><Pill tone={ACTION_TONES[l.action] || "neutral"}>{l.action}</Pill></td>
                <td className="px-4 py-3 text-xs font-mono text-slate-600">{l.target_type}{l.target_id ? `:${l.target_id.slice(0, 8)}` : ""}</td>
                <td className="px-4 py-3 text-xs font-mono text-slate-500 max-w-xs truncate">{l.meta ? JSON.stringify(l.meta) : ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
